import React from 'react'
import BigHeader from './BigHeader'
import SmallHeader from './SmallHeader'

function Header() {
  return (
<header>
<SmallHeader />
<BigHeader />
        </header>
  )
}

export default Header